<div class="grid-detail-wrap border bg-white mb-4">
  <div class="row justify-content-between mb-4 color-grey-label font-size-13 text-nowrap">
    <div class="col-md-11">
      <div class="row mb-3 align-items-center">
        <div class="col-xl-5">
          {{ 'NOTIFICATION_TEMPLATES_NAME' | translate }}
        </div>
        <div class="col">
          <dx-text-area [(value)]="this.notificationTemplate.name"></dx-text-area>
        </div>
      </div>
      <div class="row mb-3 align-items-center">
        <div class="col-xl-5">
          {{ 'NOTIFICATION_TEMPLATES_DESCRIPTION' | translate }}
        </div>
        <div class="col">
          <dx-text-area [(value)]="this.notificationTemplate.notes"></dx-text-area>
        </div>
      </div>
      <div class="row mb-3 align-items-center">
        <div class="col-xl-5">
          {{ 'NOTIFICATION_TEMPLATES_TITLE' | translate }}
        </div>
        <div class="col">
          <dx-text-area [(value)]="this.notificationTemplate.subject"></dx-text-area>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="row mb-3 align-items-center">
        <div class="col-xl-6">
          {{ 'NOTIFICATION_TEMPLATES_TYPE' | translate }}
        </div>
        <div class="col">
          <dx-text-area [(value)]="this.notificationTemplate.subsystem.value" [disabled]="true"></dx-text-area>
          <!--TODO: <dx-select-box></dx-select-box>-->
        </div>
      </div>
      <div class="row mb-3 align-items-center">
        <div class="col-xl-6">
          {{ 'NOTIFICATION_TEMPLATES_SENDER' | translate }}
        </div>
        <div class="col">
          <dx-text-area [(value)]="this.notificationTemplate.sender"></dx-text-area>
        </div>
      </div>
      <div class="row mb-3 align-items-center">
        <div class="col-xl-6">
          {{ 'NOTIFICATION_TEMPLATES_PRIORITY' | translate }}
        </div>
        <div class="col">
          <dx-text-area [(value)]="this.notificationTemplate.priority" [disabled]="true"></dx-text-area>
          <!--TODO: <dx-select-box></dx-select-box>-->
        </div>
      </div>
    </div>
  </div>

  {{ 'NOTIFICATION_TEMPLATES_BODY' | translate }}
  <dx-html-editor [(value)]="this.notificationTemplate.body" [height]="500" class="html-editor-notification mb-3">
    <dxo-toolbar>
      <dxi-item name="undo"></dxi-item>
      <dxi-item name="redo"></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item name="size" [acceptedValues]="['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt']"></dxi-item>
      <dxi-item
        name="font"
        [acceptedValues]="[
          'Arial',
          'Courier New',
          'Georgia',
          'Impact',
          'Lucida Console',
          'Tahoma',
          'Times New Roman',
          'Verdana',
        ]"></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item name="bold"></dxi-item>
      <dxi-item name="italic"></dxi-item>
      <dxi-item name="strike"></dxi-item>
      <dxi-item name="underline"></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item name="alignLeft"></dxi-item>
      <dxi-item name="alignCenter"></dxi-item>
      <dxi-item name="alignRight"></dxi-item>
      <dxi-item name="alignJustify"></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item name="orderedList"></dxi-item>
      <dxi-item name="bulletList"></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item name="header" [acceptedValues]="[false, 1, 2, 3, 4, 5]"></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item name="color"></dxi-item>
      <dxi-item name="background"></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item name="link"></dxi-item>
      <dxi-item name="image"></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item name="clear"></dxi-item>
      <dxi-item name="codeBlock"></dxi-item>
      <dxi-item name="blockquote"></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item name="insertTable"></dxi-item>
      <dxi-item name="deleteTable"></dxi-item>
      <dxi-item name="insertRowAbove"></dxi-item>
      <dxi-item name="insertRowBelow"></dxi-item>
      <dxi-item name="deleteRow"></dxi-item>
      <dxi-item name="insertColumnLeft"></dxi-item>
      <dxi-item name="insertColumnRight"></dxi-item>
      <dxi-item name="deleteColumn"></dxi-item>
      <dxi-item name="separator"></dxi-item>
      <dxi-item widget="dxButton" [options]="this.toolbarButtonOptions"></dxi-item>
    </dxo-toolbar>
  </dx-html-editor>

  <app-notification-template-key-words-details></app-notification-template-key-words-details>
</div>

<dx-button text="{{ 'SAVE' | translate }}" icon="mdi mdi-content-save" class="btn" (onClick)="this.save()"></dx-button>

<dx-popup [showTitle]="true" title="{{ 'NOTIFICATION_TEMPLATES_BODY' | translate }} (HTML)" [(visible)]="popupVisible">
  <div>{{ this.notificationTemplate.body }}</div>
</dx-popup>
